import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function UpdateAdminService(data, token,id) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(data);
      const response = await Axios.put(
        `${URL_AUTH}/api/admin/v1/admins/${id}`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response);
    } catch (error) {
      reject(error);
      console.log(error);
    }
  });
}